import React from 'react';

export const ProblemHeader: React.FC = () => {
  return (
    <>
      <h2 className="problem-title">160. 相交链表</h2>
      
      <div className="problem-tags">
        <span className="difficulty-tag">简单</span>
        <span className="tag"><i className="tag-icon">🏷️</i> 相关标签</span>
        <span className="tag"><i className="tag-icon">🏢</i> 相关企业</span>
      </div>
    </>
  );
}; 